import type { AutosaveState } from '../../../hooks/useDebouncedAutosave';

const CONFIG: Record<AutosaveState, { label: string; className: string } | null> = {
  idle: null,
  saving: { label: 'Wird gespeichert…', className: 'text-gray-500' },
  saved: { label: 'Gespeichert', className: 'text-green-600' },
  error: { label: 'Nicht gespeichert — Verbindung prüfen', className: 'text-red-600' },
};

export function VgAutosaveIndicator({ state }: { state: AutosaveState }) {
  const config = CONFIG[state];
  if (!config) return null;

  return <span className={`text-xs ${config.className}`}>{config.label}</span>;
}
